import { render } from "./Home.vue?vue&type=template&id=17007959"
const script = {}
script.render = render

export default script